import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";

export default class CardAdminModifierCodeGeneral extends CardClass {
    /**
     * Render the content of the card.
     */
    renderContent() {
        return (
            <MUIGrid container spacing={2}>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.modifierCode ? this.props.modifierCode.code : ""}
                        autoFocus={true}
                        size="small"
                        label="Code"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 2,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ code: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ code: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.code ? true : false}
                        helperText={this.props.validationIssues.code ? this.props.validationIssues.code : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={8}>
                    <MUITextField
                        value={this.props.modifierCode ? this.props.modifierCode.description : ""}
                        size="small"
                        label="Description"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ description: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ description: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.description ? true : false}
                        helperText={this.props.validationIssues.description ? this.props.validationIssues.description : ""}
                    />
                </MUIGrid>
            </MUIGrid>
        );
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "General";
    }
}